export default {
  data() {
    return {
      deposits: [
        {
          id: 4,
          name: "USERS",
          alias: "USERS",
          dpChartTab: "USERS",
          ex: true,
          combine: true,
          presetTabs: true,
          statisticTab: true
        },
        {
          id: 1,
          name: "Brokers",
          alias: "BROKERS",
          dpChartTab: "BROKERS",
          presetTabs: true
        },
        {
          id: 2,
          name: "Status",
          alias: "STATUS",
          dpChartTab: "STATUSES"
        },
        {
          id: 3,
          name: "Quant",
          alias: "QUANTITY",
          dpChartTab: "QUANTITY"
        },
        {
          id: 5,
          name: "Support",
          alias: "SUPPORT",
          dpChartTab: ""
        }
      ]
    };
  },

  created() {
    //this.insertAndShift(this.deposits, 4, 0);

    if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
      this.deposits = [
        ...this.deposits,

        {
          id: 6,
          name: "Conve",
          alias: "CONVERT",
          dpChartTab: "CONVERSIONS"
        },
        {
          id: 7,
          name: "2nd-V",
          alias: "SECUSERS",
          dpChartTab: "2VOICE"
        },
        {
          id: 8,
          name: "Leading",
          alias: "LEADING",
          dpChartTab: "LEADING"
        }
      ];
    }
  },
  methods: {
    insertAndShift(arr, from, to) {
      let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
      arr.splice(to, 0, cutOut); // insert it at index 'to'
    }
  }
};
